import React from "react";
import styled from "styled-components";
import { Button } from "react-bootstrap";
import YearAmount from "../../basics/YearAmount";
import useLanguage from "../../../../utilities/useLanguage";
import { getTranslation } from "../../translations";

const MobileFooterContainer = styled.div`

    display:none;

    @media(min-width:360px){
        .btn{
            margin-top:.7rem;
        }
    } 

    @media(max-width:767px) {
        position: fixed;
        display:block;
        z-index:1004;
        bottom:0;
        left:0;
        background-color: ${props => props.theme.primary};
        text-align:center;
        width:100%;
        border-top:3px solid ${props => props.theme.secondary};
        padding:10px;
    }

`;
export default (props) => {
    const { show, rate, applyNowUrl } = props;
    const { lang } = useLanguage();
    if (show && rate.isSet) {
        return (
            <MobileFooterContainer>
                <YearAmount monthlyPayment={rate.monthlyPayment} initialRate={rate.rate.initialRate} apr={rate.rate.disclosureInformation.apr} className="col-8 text-white float-left mobile-footer pr-2" percentageClassName="text-white" perMonthClassName="p-1" />
                <div className="col-4 float-left">
                    <Button className="btn btn-outline-light p-3" href={applyNowUrl} >{getTranslation(lang).apply}</Button>
                </div>
            </MobileFooterContainer>
        );
    } else {
        return null;
    }

};